import {Component} from '@angular/core';

@Component({
  selector: 'vui-inverted-logo',
  templateUrl: './inverted-logo.component.html',
  styleUrls: ['./inverted-logo.component.scss']
})
export class InvertedLogoComponent {

}
